<script>
export default {
    name: 'SeriesSelectorStepNav',
    props: {
        steps: { type: Array, required: true },
        questionId: { type: Number, required: true }
    },
    emits: ['select'],
    methods: {
        isPreviousStep(index) {
            return index < this.steps.findIndex(step => step.questionId === this.questionId);
        }
    }
};
</script>

<template>
    <nav v-if="steps.length > 0" class="pb-md-3">
        <ol class="steps d-md-flex">
            <li
                v-for="(step, index) in steps"
                :key="step.id"
                class="step"
                :class="{
                    active: step.questionId === questionId,
                    previous: isPreviousStep(index)
                }"
                :style="{ width: `${100 / steps.length}%`}"
                data-test="step"
            >
                <button
                    :disabled="!isPreviousStep(index)"
                    data-test="step-btn"
                    @click="$emit('select', index)"
                >
                    <span data-test="step-number">{{ index + 1 }}.&nbsp;</span>
                    <span class="ml-1" data-test="step-name">{{ step.name.toUpperCase() }}</span>
                </button>
                <slot v-if="step.questionId === questionId" />
            </li>
        </ol>
    </nav>
</template>